/**
 * TCG buyback (Ankauf) — bulk-only, cash vs shop-credit payout.
 */
(() => {
  const root = document.querySelector('[data-tcg-ankauf]');
  if (!root) return;

  const PAYOUT = {
    SHOP_CREDIT: 'shop_credit',
    CASH: 'cash',
  };

  const SUBMIT_MODE = {
    SHOPIFY: 'shopify',
    COCKPIT: 'cockpit',
    AUTO: 'auto',
  };

  const PAYOUT_LABELS = {
    [PAYOUT.SHOP_CREDIT]: 'Shop-Gutschein',
    [PAYOUT.CASH]: 'Bar',
  };

  const ALT_LABELS = {
    [PAYOUT.SHOP_CREDIT]: 'Alternativ Bar',
    [PAYOUT.CASH]: 'Alternativ Gutschein',
  };

  const BULK_NORMAL_TIERS = {
    [PAYOUT.SHOP_CREDIT]: [
      { min: 1, rate: 0.03, level: 1 },
      { min: 500, rate: 0.035, level: 2 },
      { min: 2000, rate: 0.04, level: 3 },
    ],
    [PAYOUT.CASH]: [
      { min: 1, rate: 0.018, level: 1 },
      { min: 500, rate: 0.021, level: 2 },
      { min: 2000, rate: 0.024, level: 3 },
    ],
  };

  const BULK_HOLO_TIERS = {
    [PAYOUT.SHOP_CREDIT]: [
      { min: 1, rate: 0.07, level: 1 },
      { min: 200, rate: 0.08, level: 2 },
      { min: 1000, rate: 0.09, level: 3 },
    ],
    [PAYOUT.CASH]: [
      { min: 1, rate: 0.042, level: 1 },
      { min: 200, rate: 0.048, level: 2 },
      { min: 1000, rate: 0.054, level: 3 },
    ],
  };

  const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
  const submitMode = root.dataset.submitMode || SUBMIT_MODE.SHOPIFY;
  const usesShopifySubmit = () =>
    submitMode === SUBMIT_MODE.SHOPIFY || submitMode === SUBMIT_MODE.AUTO;
  const usesCockpitSubmit = () =>
    submitMode === SUBMIT_MODE.COCKPIT || submitMode === SUBMIT_MODE.AUTO;
  const shopifyFallbackForm = document.getElementById('AnkaufShopifyFallback');
  const shopifyEmailField = root.querySelector('[data-ankauf-shopify-email]') || document.querySelector('[data-ankauf-shopify-email]');
  const shopifyNameField = root.querySelector('[data-ankauf-shopify-name]') || document.querySelector('[data-ankauf-shopify-name]');
  const shopifyBodyField = root.querySelector('[data-ankauf-shopify-body]') || document.querySelector('[data-ankauf-shopify-body]');
  const form = root.querySelector('[data-ankauf-form]');
  const bulkNormal = root.querySelector('[data-ankauf-bulk-normal]');
  const bulkHolo = root.querySelector('[data-ankauf-bulk-holo]');
  const payoutInputs = root.querySelectorAll('[data-ankauf-payout]');
  const previewEmpty = root.querySelector('[data-ankauf-preview-empty]');
  const previewDetails = root.querySelector('[data-ankauf-preview-details]');
  const previewBox = root.querySelector('[data-ankauf-preview]');
  const tileNormalRate = root.querySelector('[data-ankauf-tile-normal-rate]');
  const tileHoloRate = root.querySelector('[data-ankauf-tile-holo-rate]');
  const tileNormalProgress = root.querySelector('[data-ankauf-tile-normal-progress]');
  const tileHoloProgress = root.querySelector('[data-ankauf-tile-holo-progress]');
  const previewBulkEls = root.querySelectorAll('[data-ankauf-preview-bulk]');
  const previewTotalEls = root.querySelectorAll('[data-ankauf-preview-total]');
  const previewNormalTierRow = root.querySelector('[data-ankauf-preview-normal-tier]');
  const previewHoloTierRow = root.querySelector('[data-ankauf-preview-holo-tier]');
  const previewAltRow = root.querySelector('[data-ankauf-preview-alt-row]');
  const previewShippingBonusRow = root.querySelector('[data-ankauf-preview] [data-ankauf-shipping-bonus-row]');
  const previewShippingBonusNote = root.querySelector('[data-ankauf-preview] [data-ankauf-shipping-bonus-note]');
  const previewAltEls = root.querySelectorAll('[data-ankauf-preview-alt]');
  const altLabelEls = root.querySelectorAll('[data-ankauf-alt-label]');
  const previewPayoutLabel = root.querySelector('[data-ankauf-preview-payout-label]');
  const mobilePayoutLabels = root.querySelectorAll('[data-ankauf-mobile-payout-label]');
  const normalRateEls = root.querySelectorAll('[data-ankauf-normal-rate]');
  const holoRateEls = root.querySelectorAll('[data-ankauf-holo-rate]');
  const tierTableNormal = root.querySelector('.tcg-ankauf__tier-table:not([data-ankauf-tier-table])');
  const tierTableHolo = root.querySelector('[data-ankauf-tier-table="holo"]');
  const feedback = root.querySelector('[data-ankauf-feedback]');
  const modal = root.querySelector('[data-ankauf-modal]');
  const modalFeedback = root.querySelector('[data-ankauf-modal-feedback]');
  const modalTotal = root.querySelector('[data-ankauf-modal-total]');
  const modalPayoutLabel = root.querySelector('[data-ankauf-modal-payout-label]');
  const modalNormalRow = root.querySelector('[data-ankauf-modal-normal-row]');
  const modalNormalEl = root.querySelector('[data-ankauf-modal-normal]');
  const modalHoloRow = root.querySelector('[data-ankauf-modal-holo-row]');
  const modalHoloEl = root.querySelector('[data-ankauf-modal-holo]');
  const modalBonusRow = root.querySelector('[data-ankauf-modal-bonus-row]');
  const modalAltRow = root.querySelector('[data-ankauf-modal-alt-row]');
  const modalAltLabel = root.querySelector('[data-ankauf-modal-alt-label]');
  const modalAltEl = root.querySelector('[data-ankauf-modal-alt]');
  const emailInput = root.querySelector('[data-ankauf-email]');
  const checkboxWraps = root.querySelectorAll('[data-ankauf-checkbox-wrap]');
  const openModalBtns = root.querySelectorAll('[data-ankauf-open-modal]');
  const closeModalBtns = root.querySelectorAll('[data-ankauf-modal-close]');
  const submitBtns = root.querySelectorAll('[data-ankauf-submit]');
  const exNm = root.querySelector('[data-ankauf-ex-nm]');
  const noEnergy = root.querySelector('[data-ankauf-no-energy]');
  const mobileBar = root.querySelector('[data-ankauf-mobile-bar]');
  const formStage = root.querySelector('[data-ankauf-form-stage]');
  const successScreen = root.querySelector('[data-ankauf-success-screen]');
  const successTextEl = root.querySelector('[data-ankauf-success-text]');
  const successCloseBtn = root.querySelector('[data-ankauf-success-close]');

  let currentPayout = PAYOUT.SHOP_CREDIT;
  let lastFocusedBeforeModal = null;
  let isSubmitting = false;
  let shopifyFallbackPending = false;
  let shopifySubmitTimeoutId = null;

  const clearShopifySubmitTimeout = () => {
    if (shopifySubmitTimeoutId !== null) {
      window.clearTimeout(shopifySubmitTimeoutId);
      shopifySubmitTimeoutId = null;
    }
  };

  const resetShopifySubmitState = (errorMessage) => {
    clearShopifySubmitTimeout();
    shopifyFallbackPending = false;
    isSubmitting = false;
    updateModalSubmitReady();
    if (errorMessage) {
      showModalFeedback(errorMessage, 'error');
    }
  };

  const populateShopifyFallbackFields = (email, name, message, bulk) => {
    shopifyEmailField.value = email;
    if (shopifyNameField) shopifyNameField.value = name || '';
    shopifyBodyField.value = buildShopifyContactBody(email, name, message, bulk);
    if (!shopifyBodyField.value.trim()) {
      throw new Error('Anfrage-Text konnte nicht erstellt werden.');
    }
  };

  const submitShopifyFallback = (email, name, message, bulk) => {
    if (!shopifyFallbackForm || !shopifyEmailField || !shopifyBodyField) {
      throw new Error(
        'Shop-Formular nicht verfügbar. Bitte später erneut versuchen oder uns direkt an info@kartenladen24.de schreiben.'
      );
    }

    shopifyFallbackPending = true;
    clearShopifySubmitTimeout();
    shopifySubmitTimeoutId = window.setTimeout(() => {
      if (!shopifyFallbackPending) return;
      resetShopifySubmitState(
        'Senden hat zu lange gedauert. Bitte erneut auf „Ankauf anfragen“ klicken — ggf. kurz die Sicherheitsprüfung bestätigen.'
      );
    }, 30000);

    const finalizeSubmit = () => {
      populateShopifyFallbackFields(email, name, message, bulk);
      shopifyFallbackForm.querySelectorAll('input[name="return_to"]').forEach((field) => {
        field.value = '/pages/karten-ankauf?ankauf_sent=1';
      });
      // requestSubmit() fires the submit event so Shopify hCaptcha can attach its token.
      // form.submit() bypasses that handler and causes "invalid parameters".
      shopifyFallbackForm.requestSubmit();
    };

    const captchaReady =
      shopifyFallbackForm.dataset.cptcha === 'true' ||
      shopifyFallbackForm.dataset.shopifyCaptcha === 'true';

    if (window.Shopify?.captcha?.protect && !captchaReady) {
      window.Shopify.captcha.protect(shopifyFallbackForm, finalizeSubmit);
      return;
    }

    try {
      finalizeSubmit();
    } catch (err) {
      resetShopifySubmitState(err.message || 'Senden fehlgeschlagen.');
      throw err;
    }
  };

  const resolveApiBases = () => {
    if (typeof window.KL24?.resolveCockpitApiBases === 'function') {
      return window.KL24.resolveCockpitApiBases();
    }
    return apiBase ? [apiBase] : [];
  };

  const cockpitHeaders = (base, extra = {}) => {
    if (typeof window.KL24?.cockpitRequestHeaders === 'function') {
      return window.KL24.cockpitRequestHeaders(base, extra);
    }
    return { Accept: 'application/json', ...extra };
  };

  const humanizeFetchError = (err) => {
    const message = String(err?.message || err || '');
    if (/networkerror|failed to fetch|load failed/i.test(message)) {
      return 'Verbindung zum Server fehlgeschlagen. Wir versuchen es über das Shop-Formular …';
    }
    return message || 'Senden fehlgeschlagen.';
  };

  const buildShopifyContactBody = (email, name, message, bulk) => {
    const payoutLabel = PAYOUT_LABELS[currentPayout];
    const lines = [
      'Pokémon Bulk-Ankauf über kartenladen24.de',
      '',
      `Kunden-E-Mail: ${email}`,
      name ? `Name: ${name}` : null,
      `Auszahlungsart: ${payoutLabel}`,
      `Versand-Bonus: ${currentPayout === PAYOUT.SHOP_CREDIT ? 'möglich (bis 5 €; Foto frankiertes Paket, nicht in Schätzung)' : 'nein'}`,
      `Bulk Normal: ${bulk.normal}`,
      `Bulk Glitzer: ${bulk.holo}`,
      `Geschätzter Wert: ${money(bulk.total)}`,
      bulk.normalTier ? `Staffel Normal: ${rateLabel(bulk.normalTier.rate)}/St (ab ${bulk.normalTier.min})` : null,
      bulk.holoTier ? `Staffel Glitzer: ${rateLabel(bulk.holoTier.rate)}/St (ab ${bulk.holoTier.min})` : null,
      'Bestätigt EX/NM+: ja',
      'Bestätigt keine Basis-Energie: ja',
      message ? '' : null,
      message ? 'Nachricht des Kunden:' : null,
      message || null,
    ].filter((line) => line !== null);
    return lines.join('\n');
  };

  const submitViaShopify = (email, name, message, bulk) => {
    persistAnkaufSuccessContext(email, name);
    submitShopifyFallback(email, name, message, bulk);
  };

  const ANKAUF_SUCCESS_STORAGE_KEY = 'kl24_ankauf_success_v1';
  const ANKAUF_SUCCESS_VIEW_KEY = 'kl24_ankauf_success_view_v1';
  const ANKAUF_SUCCESS_DISMISSED_KEY = 'kl24_ankauf_success_dismissed_v1';

  const readStorageJson = (key) => {
    for (const store of [sessionStorage, localStorage]) {
      try {
        const raw = store.getItem(key);
        if (!raw) continue;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch {
        /* ignore */
      }
    }
    return null;
  };

  const writeStorageJson = (key, value) => {
    const raw = JSON.stringify(value);
    try {
      sessionStorage.setItem(key, raw);
    } catch {
      /* ignore */
    }
    try {
      localStorage.setItem(key, raw);
    } catch {
      /* ignore */
    }
  };

  const clearStorageKey = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* ignore */
    }
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  };

  const persistAnkaufSuccessContext = (email, name) => {
    clearStorageKey(ANKAUF_SUCCESS_DISMISSED_KEY);
    clearStorageKey(ANKAUF_SUCCESS_VIEW_KEY);
    writeStorageJson(ANKAUF_SUCCESS_STORAGE_KEY, {
      email: String(email || '').trim(),
      name: String(name || '').trim(),
      saved_at: Date.now(),
      path: window.location.pathname,
    });
  };

  const peekAnkaufSuccessContext = () => {
    const parsed = readStorageJson(ANKAUF_SUCCESS_STORAGE_KEY);
    if (!parsed) return null;
    if (Date.now() - Number(parsed.saved_at || 0) > 24 * 60 * 60 * 1000) return null;
    if (parsed.path && parsed.path !== window.location.pathname) return null;
    return parsed;
  };

  const consumeAnkaufSuccessContext = () => {
    const parsed = peekAnkaufSuccessContext();
    if (!parsed) return null;
    clearStorageKey(ANKAUF_SUCCESS_STORAGE_KEY);
    return parsed;
  };

  const cleanAnkaufReturnParams = () => {
    const params = new URLSearchParams(window.location.search);
    let changed = false;
    for (const key of ['contact_posted', 'ankauf_sent', 'form_type']) {
      if (!params.has(key)) continue;
      params.delete(key);
      changed = true;
    }
    if (!changed) return;
    const nextQuery = params.toString();
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}${window.location.hash}`
    );
  };

  const wasAnkaufSuccessDismissed = () => {
    try {
      return sessionStorage.getItem(ANKAUF_SUCCESS_DISMISSED_KEY) === window.location.pathname;
    } catch {
      return false;
    }
  };

  const markAnkaufSuccessDismissed = () => {
    try {
      sessionStorage.setItem(ANKAUF_SUCCESS_DISMISSED_KEY, window.location.pathname);
    } catch {
      /* ignore */
    }
    clearStorageKey(ANKAUF_SUCCESS_VIEW_KEY);
  };

  const persistAnkaufSuccessView = (email) => {
    writeStorageJson(ANKAUF_SUCCESS_VIEW_KEY, {
      email: String(email || '').trim(),
      path: window.location.pathname,
    });
  };

  const peekAnkaufSuccessView = () => {
    const parsed = readStorageJson(ANKAUF_SUCCESS_VIEW_KEY);
    if (!parsed || parsed.path !== window.location.pathname) return null;
    return parsed;
  };

  const detectAnkaufPostSubmit = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') return true;
    if (params.get('ankauf_sent') === '1') return true;
    const pending = peekAnkaufSuccessContext();
    if (!pending) return false;
    return Date.now() - Number(pending.saved_at || 0) < 15 * 60 * 1000;
  };

  const hideAnkaufSuccessScreen = () => {
    if (successScreen) successScreen.hidden = true;
    if (formStage) formStage.hidden = false;
    markAnkaufSuccessDismissed();
    updatePreviewTotals();
  };

  const ANKAUF_PACKAGE_NOTE =
    'In der E-Mail findest du deine Anfrage-Nummer. Bitte lege einen kurzen Zettel mit dieser Nummer mit ins Paket — so können wir deine Sendung schneller zuordnen.';

  const ANKAUF_ESTIMATE_NOTICE =
    'Der angezeigte Wert ist eine unverbindliche Schätzung. Ich prüfe jede Anfrage persönlich und melde mich mit einer Bestätigung, bevor du Karten verschickst. Bitte verschicke noch keine Karten, bis du meine Bestätigung hast.';

  const fillAnkaufSuccessText = (email, ticketId) => {
    if (!successTextEl) return;
    successTextEl.replaceChildren();

    const lead = document.createElement('p');
    lead.className = 'tcg-ankauf__success-screen-lead';
    if (ticketId) {
      lead.textContent = `Vielen Dank! Deine Anfrage #${ticketId} ist eingegangen.`;
    } else if (email) {
      lead.append('Vielen Dank! Wir melden uns in Kürze per E-Mail unter ');
      lead.appendChild(Object.assign(document.createElement('strong'), { textContent: email }));
      lead.append('.');
    } else {
      lead.textContent =
        'Vielen Dank! Wir melden uns in Kürze per E-Mail an die von dir angegebene Adresse.';
    }

    const estimateNote = document.createElement('p');
    estimateNote.className = 'tcg-ankauf__success-screen-estimate';
    estimateNote.textContent = ANKAUF_ESTIMATE_NOTICE;

    const note = document.createElement('p');
    note.className = 'tcg-ankauf__success-screen-note';
    note.textContent = ANKAUF_PACKAGE_NOTE;

    successTextEl.append(lead, estimateNote, note);
  };

  const showAnkaufSuccessScreen = (email, options = {}) => {
    const { persist = true, ticketId = null } = options;
    closeCheckoutModal();

    if (formStage) formStage.hidden = true;
    if (mobileBar) mobileBar.hidden = true;
    hideFeedback();

    if (successScreen && successTextEl) {
      fillAnkaufSuccessText(email, ticketId);
      successScreen.hidden = false;
      if (persist) persistAnkaufSuccessView(email);
      window.requestAnimationFrame(() => {
        successScreen.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      const ticketPrefix = ticketId ? `Deine Anfrage #${ticketId} ist eingegangen. ` : 'Deine Anfrage ist eingegangen. ';
      showFeedback(
        email
          ? `${ticketPrefix}Wir melden uns unter ${email}. ${ANKAUF_ESTIMATE_NOTICE} ${ANKAUF_PACKAGE_NOTE}`
          : `${ticketPrefix}Wir melden uns in Kürze per E-Mail. ${ANKAUF_ESTIMATE_NOTICE} ${ANKAUF_PACKAGE_NOTE}`,
        'success'
      );
    }
  };

  const submitToCockpit = async (formData) => {
    const bases = resolveApiBases();
    if (!bases.length) return null;

    let lastError = null;
    for (const base of bases) {
      try {
        const response = await fetch(`${base}/integrations/ankauf/submit`, {
          method: 'POST',
          headers: cockpitHeaders(base, {}),
          body: formData,
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          const detail = body.detail || `HTTP ${response.status}`;
          throw new Error(typeof detail === 'string' ? detail : 'Senden fehlgeschlagen.');
        }
        return body;
      } catch (err) {
        lastError = err;
        console.warn('[KL24 Ankauf] Cockpit-Versuch fehlgeschlagen:', base, err);
      }
    }
    throw lastError || new Error('Cockpit nicht erreichbar.');
  };

  const handleShopifyContactPosted = () => {
    if (wasAnkaufSuccessDismissed()) {
      cleanAnkaufReturnParams();
      return;
    }

    const activeView = peekAnkaufSuccessView();
    if (activeView) {
      cleanAnkaufReturnParams();
      showAnkaufSuccessScreen(activeView.email, { persist: false });
      return;
    }

    if (!detectAnkaufPostSubmit()) return;

    clearShopifySubmitTimeout();
    shopifyFallbackPending = false;
    isSubmitting = false;
    cleanAnkaufReturnParams();

    const context = peekAnkaufSuccessContext();
    const email = context?.email || '';
    consumeAnkaufSuccessContext();
    showAnkaufSuccessScreen(email);
  };

  const euroFmt = () => window.Kl24EuroFormat;

  const money = (value) => {
    const fmt = euroFmt();
    if (fmt) return fmt.formatFromNumber(Number(value) || 0);
    return String(
      new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(
        Number(value) || 0
      )
    ).replace(/\s+€/g, '€');
  };

  const rateLabel = (value) => {
    const opts = { minimumFractionDigits: 2, maximumFractionDigits: 3 };
    const fmt = euroFmt();
    if (fmt) return fmt.formatFromNumber(Number(value) || 0, opts);
    return String(
      new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', ...opts }).format(
        Number(value) || 0
      )
    ).replace(/\s+€/g, '€');
  };

  const readCount = (el) => {
    const n = Number.parseInt(String(el?.value || '0'), 10);
    return Number.isFinite(n) && n > 0 ? Math.min(n, 9999) : 0;
  };

  const BULK_STEP_AMOUNT = 10;

  const syncBulkInputDisplay = (input) => {
    if (!input) return;
    const count = readCount(input);
    input.value = count > 0 ? String(count) : '';
    input.classList.toggle('is-empty', count <= 0);
  };

  const adjustBulkCount = (input, delta) => {
    if (!input) return;
    const next = Math.min(9999, Math.max(0, readCount(input) + delta));
    input.value = next > 0 ? String(next) : '';
    syncBulkInputDisplay(input);
    onInputChange();
  };

  const alternatePayout = (payout) =>
    payout === PAYOUT.CASH ? PAYOUT.SHOP_CREDIT : PAYOUT.CASH;

  const bulkTierForCount = (count, tiers) => {
    const qty = Math.max(0, count);
    if (qty <= 0) return tiers[0];
    for (let i = tiers.length - 1; i >= 0; i -= 1) {
      if (qty >= tiers[i].min) return tiers[i];
    }
    return tiers[0];
  };

  const computeBulkForPayout = (payout) => {
    const normal = readCount(bulkNormal);
    const holo = readCount(bulkHolo);
    const normalTiers = BULK_NORMAL_TIERS[payout] || BULK_NORMAL_TIERS[PAYOUT.SHOP_CREDIT];
    const holoTiers = BULK_HOLO_TIERS[payout] || BULK_HOLO_TIERS[PAYOUT.SHOP_CREDIT];
    const normalTier = bulkTierForCount(normal, normalTiers);
    const holoTier = bulkTierForCount(holo, holoTiers);
    const total =
      Math.round((normal * normalTier.rate + holo * holoTier.rate) * 100) / 100;
    return { normal, holo, normalTier, holoTier, total };
  };

  const getSelectedPayout = () => {
    const checked = root.querySelector('[data-ankauf-payout]:checked');
    const value = checked?.value;
    return value === PAYOUT.CASH ? PAYOUT.CASH : PAYOUT.SHOP_CREDIT;
  };

  const updateModalSubmitReady = () => {
    const email = emailInput?.value?.trim() || '';
    const canSubmit =
      Boolean(exNm?.checked) && Boolean(noEnergy?.checked) && email.length > 0;
    const ready = !isSubmitting && canSubmit;
    submitBtns.forEach((btn) => {
      btn.classList.toggle('is-ready', ready);
      btn.disabled = isSubmitting;
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    });
  };

  const clearCheckboxErrors = () => {
    checkboxWraps.forEach((wrap) => wrap.classList.remove('is-error'));
  };

  const markCheckboxErrors = () => {
    if (!exNm?.checked) {
      exNm?.closest('[data-ankauf-checkbox-wrap]')?.classList.add('is-error');
    }
    if (!noEnergy?.checked) {
      noEnergy?.closest('[data-ankauf-checkbox-wrap]')?.classList.add('is-error');
    }
  };

  const setOpenModalReady = (ready) => {
    openModalBtns.forEach((btn) => {
      btn.classList.toggle('is-ready', ready);
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    });
  };

  const showFeedback = (message, type) => {
    if (!feedback) return;
    feedback.hidden = false;
    feedback.textContent = message;
    feedback.classList.remove('is-error', 'is-success');
    feedback.classList.add(type === 'success' ? 'is-success' : 'is-error');
    feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const hideFeedback = () => {
    if (!feedback) return;
    feedback.hidden = true;
    feedback.textContent = '';
    feedback.classList.remove('is-error', 'is-success');
  };

  const showModalFeedback = (message, type) => {
    if (!modalFeedback) return;
    modalFeedback.hidden = false;
    modalFeedback.textContent = message;
    modalFeedback.classList.remove('is-error', 'is-success');
    modalFeedback.classList.add(type === 'success' ? 'is-success' : 'is-error');
  };

  const hideModalFeedback = () => {
    if (!modalFeedback) return;
    modalFeedback.hidden = true;
    modalFeedback.textContent = '';
    modalFeedback.classList.remove('is-error', 'is-success');
  };

  const isModalOpen = () => modal && !modal.hidden;

  const getModalFocusables = () => {
    if (!modal) return [];
    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null || el === document.activeElement);
  };

  const trapModalFocus = (event) => {
    if (!isModalOpen() || event.key !== 'Tab') return;
    const focusables = getModalFocusables();
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const formatModalCardCount = (count) =>
    count > 0 ? count.toLocaleString('de-DE') : '—';

  const updateModalSummary = () => {
    const bulk = computeBulkForPayout(currentPayout);
    const altBulk = computeBulkForPayout(alternatePayout(currentPayout));
    const label = PAYOUT_LABELS[currentPayout];
    const modalBonusFootnote = root.querySelector('[data-ankauf-modal-bonus-footnote]');
    const showBonus = currentPayout === PAYOUT.SHOP_CREDIT && bulk.total > 0;

    if (modalTotal) modalTotal.textContent = money(bulk.total);
    if (modalPayoutLabel) modalPayoutLabel.textContent = label;

    if (modalNormalRow) modalNormalRow.hidden = bulk.normal <= 0;
    if (modalNormalEl) modalNormalEl.textContent = formatModalCardCount(bulk.normal);

    if (modalHoloRow) modalHoloRow.hidden = bulk.holo <= 0;
    if (modalHoloEl) modalHoloEl.textContent = formatModalCardCount(bulk.holo);

    if (modalBonusRow) modalBonusRow.hidden = !showBonus;
    if (modalBonusFootnote) modalBonusFootnote.hidden = !showBonus;
    if (modalAltRow) modalAltRow.hidden = altBulk.total <= 0;
    if (modalAltLabel) modalAltLabel.textContent = ALT_LABELS[currentPayout];
    if (modalAltEl) modalAltEl.textContent = money(altBulk.total);
  };

  const openCheckoutModal = () => {
    const validationError = validateSubmission();
    if (validationError) {
      showFeedback(validationError, 'error');
      return;
    }
    hideFeedback();
    hideModalFeedback();
    clearCheckboxErrors();
    updateModalSummary();
    updateModalSubmitReady();
    lastFocusedBeforeModal = document.activeElement;
    if (modal) modal.hidden = false;
    document.body.classList.add('tcg-ankauf--modal-open');
    const firstFocus = exNm || root.querySelector('[data-ankauf-email]');
    firstFocus?.focus();
  };

  const closeCheckoutModal = () => {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('tcg-ankauf--modal-open');
    hideModalFeedback();
    if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
      lastFocusedBeforeModal.focus();
    }
    lastFocusedBeforeModal = null;
  };

  const highlightTierTable = (table, level) => {
    if (!table) return;
    table.querySelectorAll('[data-tier-level]').forEach((row) => {
      row.classList.toggle('is-active', Number(row.dataset.tierLevel) === level);
    });
  };

  const formatTierRange = (tier, tiers) => {
    const idx = tiers.findIndex((t) => t.level === tier.level);
    const next = idx >= 0 ? tiers[idx + 1] : null;
    if (idx === tiers.length - 1) {
      return `ab ${tier.min.toLocaleString('de-DE')} Stück`;
    }
    if (tier.min <= 1) {
      const max = (next?.min ?? tier.min) - 1;
      return `1–${max.toLocaleString('de-DE')} Stück`;
    }
    const max = next ? next.min - 1 : tier.min;
    return `${tier.min.toLocaleString('de-DE')}–${max.toLocaleString('de-DE')} Stück`;
  };

  const formatTierProgress = (count, tier, tiers) => {
    if (count <= 0) return '';
    const idx = tiers.findIndex((t) => t.level === tier.level);
    if (idx < 0 || idx >= tiers.length - 1) {
      return 'Höchster Mengenrabatt erreicht';
    }
    const next = tiers[idx + 1];
    const remaining = next.min - count;
    return `Noch ${remaining.toLocaleString('de-DE')} bis ${rateLabel(next.rate)}/St`;
  };

  const formatTileRate = (count, tier, tiers) =>
    `${rateLabel(tier.rate)}/St · ${formatTierRange(tier, tiers)}`;

  const updatePayoutUi = () => {
    currentPayout = getSelectedPayout();
    const alt = alternatePayout(currentPayout);
    const label = PAYOUT_LABELS[currentPayout];
    const altLabel = ALT_LABELS[currentPayout];

    if (previewPayoutLabel) previewPayoutLabel.textContent = label;
    mobilePayoutLabels.forEach((el) => {
      el.textContent = currentPayout === PAYOUT.CASH ? 'Bar' : 'Gutschein';
    });
    altLabelEls.forEach((el) => {
      el.textContent = altLabel;
    });

    payoutInputs.forEach((input) => {
      const option = input.closest('.tcg-ankauf__payout-option');
      option?.classList.toggle('is-selected', input.checked);
    });
  };

  const updatePreviewTotals = () => {
    currentPayout = getSelectedPayout();
    const bulk = computeBulkForPayout(currentPayout);
    const altBulk = computeBulkForPayout(alternatePayout(currentPayout));
    const hasValue = bulk.total > 0;
    const showShippingBonus = currentPayout === PAYOUT.SHOP_CREDIT && hasValue;

    previewBulkEls.forEach((el) => {
      el.textContent = money(bulk.total);
    });
    previewTotalEls.forEach((el) => {
      el.textContent = money(bulk.total);
    });
    previewAltEls.forEach((el) => {
      el.textContent = money(altBulk.total);
    });

    if (previewEmpty) previewEmpty.hidden = hasValue;
    if (previewDetails) previewDetails.hidden = !hasValue;
    if (previewBox) {
      previewBox.classList.toggle('tcg-ankauf__preview--has-value', hasValue);
      previewBox.classList.toggle('tcg-ankauf__preview--cash', currentPayout === PAYOUT.CASH);
    }
    if (previewAltRow) previewAltRow.hidden = !hasValue || altBulk.total <= 0;
    if (previewShippingBonusRow) {
      previewShippingBonusRow.hidden = !showShippingBonus;
    }
    if (previewShippingBonusNote) {
      previewShippingBonusNote.hidden = currentPayout !== PAYOUT.SHOP_CREDIT;
    }

    if (previewNormalTierRow) previewNormalTierRow.hidden = bulk.normal <= 0;
    if (previewHoloTierRow) previewHoloTierRow.hidden = bulk.holo <= 0;

    const normalTiers = BULK_NORMAL_TIERS[currentPayout];
    const holoTiers = BULK_HOLO_TIERS[currentPayout];

    normalRateEls.forEach((el) => {
      el.textContent =
        bulk.normal <= 0
          ? '—'
          : formatTileRate(bulk.normal, bulk.normalTier, normalTiers);
    });
    holoRateEls.forEach((el) => {
      el.textContent =
        bulk.holo <= 0
          ? '—'
          : formatTileRate(bulk.holo, bulk.holoTier, holoTiers);
    });

    const normalTierPreview = bulkTierForCount(readCount(bulkNormal), normalTiers);
    const holoTierPreview = bulkTierForCount(readCount(bulkHolo), holoTiers);

    highlightTierTable(tierTableNormal, bulk.normal > 0 ? normalTierPreview.level : 0);
    highlightTierTable(tierTableHolo, bulk.holo > 0 ? holoTierPreview.level : 0);

    if (tileNormalRate) {
      tileNormalRate.textContent = formatTileRate(bulk.normal, normalTierPreview, normalTiers);
    }
    if (tileHoloRate) {
      tileHoloRate.textContent = formatTileRate(bulk.holo, holoTierPreview, holoTiers);
    }
    if (tileNormalProgress) {
      const progress = formatTierProgress(bulk.normal, normalTierPreview, normalTiers);
      tileNormalProgress.textContent = progress;
      tileNormalProgress.hidden = !progress;
    }
    if (tileHoloProgress) {
      const progress = formatTierProgress(bulk.holo, holoTierPreview, holoTiers);
      tileHoloProgress.textContent = progress;
      tileHoloProgress.hidden = !progress;
    }

    if (mobileBar) {
      mobileBar.hidden = !hasValue;
    }
    setOpenModalReady(hasValue);
  };

  const onInputChange = () => {
    hideFeedback();
    updatePayoutUi();
    updatePreviewTotals();
    if (!modal?.hidden) updateModalSummary();
  };

  payoutInputs.forEach((input) => {
    input.addEventListener('change', onInputChange);
  });
  bulkNormal?.addEventListener('input', () => {
    syncBulkInputDisplay(bulkNormal);
    onInputChange();
  });
  bulkHolo?.addEventListener('input', () => {
    syncBulkInputDisplay(bulkHolo);
    onInputChange();
  });
  bulkNormal?.addEventListener('blur', () => syncBulkInputDisplay(bulkNormal));
  bulkHolo?.addEventListener('blur', () => syncBulkInputDisplay(bulkHolo));

  root.querySelectorAll('[data-ankauf-step]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const target = btn.dataset.ankaufStep;
      const dir = Number(btn.dataset.stepDir) || 0;
      const input = target === 'holo' ? bulkHolo : bulkNormal;
      adjustBulkCount(input, dir * BULK_STEP_AMOUNT);
    });
  });

  root.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-ankauf-open-modal]');
    if (!openBtn || !root.contains(openBtn)) return;
    event.preventDefault();
    openCheckoutModal();
  });

  closeModalBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      closeCheckoutModal();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (!isModalOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeCheckoutModal();
      return;
    }
    trapModalFocus(event);
  });

  exNm?.addEventListener('change', () => {
    clearCheckboxErrors();
    updateModalSubmitReady();
  });
  noEnergy?.addEventListener('change', () => {
    clearCheckboxErrors();
    updateModalSubmitReady();
  });
  emailInput?.addEventListener('input', updateModalSubmitReady);
  emailInput?.addEventListener('change', updateModalSubmitReady);
  emailInput?.addEventListener('blur', updateModalSubmitReady);

  const buildCustomerMessage = () => {
    const messageEl = root.querySelector('[data-ankauf-message]');
    const userMessage = messageEl?.value?.trim() || '';
    const prefix = `[Auszahlung: ${PAYOUT_LABELS[currentPayout]}]`;
    return userMessage ? `${prefix}\n${userMessage}` : prefix;
  };

  const validateSubmission = () => {
    const bulk = computeBulkForPayout(currentPayout);
    if (bulk.normal + bulk.holo <= 0) {
      return 'Bitte mindestens eine Bulk-Menge angeben (normale Karten und/oder Glitzer).';
    }
    return null;
  };

  form?.addEventListener('submit', async (event) => {
    if (shopifyFallbackPending) return;
    event.preventDefault();
    if (!isModalOpen()) return;

    hideModalFeedback();
    hideFeedback();

    if (!exNm?.checked || !noEnergy?.checked) {
      showModalFeedback('Bitte beide Bestätigungen oben ankreuzen — dann kannst du die Anfrage absenden.', 'error');
      markCheckboxErrors();
      exNm?.focus();
      return;
    }

    const email = emailInput?.value?.trim();
    if (!email) {
      showModalFeedback('Bitte E-Mail angeben.', 'error');
      emailInput?.focus();
      return;
    }

    const validationError = validateSubmission();
    if (validationError) {
      showModalFeedback(validationError, 'error');
      return;
    }

    const bulk = computeBulkForPayout(currentPayout);
    const name = root.querySelector('[data-ankauf-name]')?.value?.trim() || '';
    const customerMessage = buildCustomerMessage();

    isSubmitting = true;
    updateModalSubmitReady();
    showModalFeedback('Wird gesendet …', 'success');

    if (submitMode === SUBMIT_MODE.SHOPIFY) {
      try {
        submitViaShopify(email, name, customerMessage, bulk);
      } catch (err) {
        showModalFeedback(err.message || 'Senden fehlgeschlagen.', 'error');
        isSubmitting = false;
        updateModalSubmitReady();
      }
      return;
    }

    const formData = new FormData();
    formData.append('customer_email', email);
    if (name) formData.append('customer_name', name);
    formData.append('customer_message', customerMessage);
    formData.append('bulk_normal_count', String(bulk.normal));
    formData.append('bulk_holo_count', String(bulk.holo));
    formData.append('payout_method', currentPayout);
    formData.append('confirmed_ex_nm', 'true');
    formData.append('confirmed_no_basic_energy', 'true');
    formData.append('website', root.querySelector('[data-ankauf-hp]')?.value?.trim() || '');

    try {
      const bases = usesCockpitSubmit() ? resolveApiBases() : [];
      if (bases.length) {
        const data = await submitToCockpit(formData);
        if (data) {
          const total = Number(data.total_estimate_eur) || 0;
          const payoutLabel = PAYOUT_LABELS[currentPayout];
          let successMsg = `Danke! Deine Anfrage #${data.id} ist eingegangen. Geschätzter ${payoutLabel}-Wert: ${money(total)}. Wir melden uns nach Prüfung per E-Mail. ${ANKAUF_ESTIMATE_NOTICE} ${ANKAUF_PACKAGE_NOTE}`;
          if (currentPayout === PAYOUT.SHOP_CREDIT) {
            successMsg += ' Optional: Foto vom Paket mit sichtbarer Frankierung per E-Mail — bis zu 5 € Versand-Bonus auf den Gutschein nach Prüfung.';
          }
          closeCheckoutModal();
          showFeedback(successMsg, 'success');
          form.reset();
          const defaultPayout = root.querySelector('[data-ankauf-payout][value="shop_credit"]');
          if (defaultPayout) defaultPayout.checked = true;
          syncBulkInputDisplay(bulkNormal);
          syncBulkInputDisplay(bulkHolo);
          onInputChange();
          return;
        }
      }

      if (usesShopifySubmit()) {
        showModalFeedback('Cockpit nicht erreichbar — sende über Shop-Formular …', 'success');
        submitViaShopify(email, name, customerMessage, bulk);
        return;
      }

      showModalFeedback('Cockpit nicht erreichbar. Bitte später erneut versuchen.', 'error');
    } catch (err) {
      const friendly = humanizeFetchError(err);
      if (usesShopifySubmit() && shopifyFallbackForm) {
        try {
          showModalFeedback(`${friendly}`, 'success');
          submitViaShopify(email, name, customerMessage, bulk);
          return;
        } catch (fallbackErr) {
          showModalFeedback(fallbackErr.message || friendly, 'error');
        }
      } else {
        showModalFeedback(friendly, 'error');
      }
    } finally {
      isSubmitting = false;
      updateModalSubmitReady();
    }
  });

  successCloseBtn?.addEventListener('click', hideAnkaufSuccessScreen);

  /**
   * Shopify's #shop-hcaptcha-badge-container is an expanded ~300×55 privacy strip with
   * inline styles — not a controllable 44–56 px collapsed icon. Per hCaptcha Invisible
   * docs / FAQ, on-page Privacy + Terms text is the required disclosure; then the
   * floating badge may be hidden. We show .tcg-ankauf__hcaptcha-disclosure in the
   * sticky bar and force-hide the floating badge on mobile (CSS + inline !important
   * to beat hCaptcha injection). No scale().
   * @see https://docs.hcaptcha.com/invisible
   * @see https://docs.hcaptcha.com/faq
   */
  const hideFloatingHcaptchaWhenDisclosureVisible = () => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const disclosure = root.querySelector('[data-ankauf-hcaptcha-disclosure]');
    const bar = root.querySelector('[data-ankauf-mobile-bar]');
    const disclosureVisible =
      !!disclosure &&
      !!bar &&
      !bar.hidden &&
      getComputedStyle(disclosure).display !== 'none';
    if (!disclosureVisible) return;
    const badge = document.querySelector('#shop-hcaptcha-badge-container');
    if (!badge) return;
    badge.style.setProperty('visibility', 'hidden', 'important');
    badge.style.setProperty('opacity', '0', 'important');
    badge.style.setProperty('pointer-events', 'none', 'important');
    badge.style.setProperty('width', '0', 'important');
    badge.style.setProperty('height', '0', 'important');
    badge.style.setProperty('max-width', '0', 'important');
    badge.style.setProperty('max-height', '0', 'important');
    badge.style.setProperty('overflow', 'hidden', 'important');
    badge.style.setProperty('clip', 'rect(0, 0, 0, 0)', 'important');
    badge.setAttribute('data-kl24-hcaptcha-parked', 'disclosure');
  };

  hideFloatingHcaptchaWhenDisclosureVisible();
  window.addEventListener('resize', hideFloatingHcaptchaWhenDisclosureVisible);
  window.addEventListener('orientationchange', hideFloatingHcaptchaWhenDisclosureVisible);
  if (typeof MutationObserver !== 'undefined') {
    const mo = new MutationObserver(() => hideFloatingHcaptchaWhenDisclosureVisible());
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });
    window.setTimeout(() => mo.disconnect(), 25000);
  }
  window.setTimeout(hideFloatingHcaptchaWhenDisclosureVisible, 500);
  window.setTimeout(hideFloatingHcaptchaWhenDisclosureVisible, 1500);
  window.setTimeout(hideFloatingHcaptchaWhenDisclosureVisible, 4000);

  updatePayoutUi();
  syncBulkInputDisplay(bulkNormal);
  syncBulkInputDisplay(bulkHolo);
  updatePreviewTotals();
  updateModalSubmitReady();
  handleShopifyContactPosted();
})();
